import Section from './Section'

export { Section }
export default Section
